module.exports = __webpack_public_path__ + "img/leihs1.26ecdd72.png";